module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "NameCard"
  }, [_vm._m(0), _vm._v(" "), (_vm.availableNames) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n      " + _vm._s(_vm.currentIndex + 1) + " / " + _vm._s(_vm.availableNames) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-nav"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('Card', {
    attrs: {
      "name": _vm.currentName,
      "rating": _vm.rating,
      "addRating": _vm.addRating,
      "removeRating": _vm.removeRating,
      "addComment": _vm.addComment
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_c('button', {
    staticClass: "btn",
    class: [_vm.prevAvailable ? '' : 'disabled'],
    on: {
      "click": function($event) {
        _vm.prevName()
      }
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_c('button', {
    staticClass: "btn",
    class: [_vm.nextAvailable ? '' : 'disabled'],
    on: {
      "click": function($event) {
        _vm.nextName()
      }
    }
  }, [_vm._v("Next")])])])])])]) : _c('div', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "empty-icon"
  }, [_c('i', {
    staticClass: "icon icon-people"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "empty-title"
  }, [_vm._v("You have no new names")]), _vm._v(" "), _c('p', {
    staticClass: "empty-meta"
  }, [_vm._v("Add a new name!")]), _vm._v(" "), _c('div', {
    staticClass: "empty-action"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("On the frontpage")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar"
  }, [_c('section', {
    staticClass: "navbar-primary"
  }, [_c('a', {
    staticClass: "navbar-brand mr-10",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Back")])]), _vm._v(" "), _c('section', {
    staticClass: "navbar-section"
  }, [_c('div', {
    staticClass: "input-group input-inline"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-a69c750e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NameCard.vue
// module id = 123
// module chunks = 1